import styled from 'styled-components';

import { font } from '../../../atoms/typography';
import { color } from '../../../atoms/colors';
import { atMinWidth } from '../../../atoms/breakpoints';
import { spacing } from '../../../atoms/spacing';
import { containers } from '../../../atoms/containers';

export const Section = styled.section`
  position: relative;
  width: 100%;
  padding: ${spacing[76]} 0px ${spacing[48]};
  border-bottom: 5px solid rgba(0, 124, 176, 0);
  background: linear-gradient(
      125deg,
      #f2f6fc 22.27%,
      rgba(255, 255, 255, 0) 47.29%
    ),
    #fff;

  ${atMinWidth.sm`
    padding: ${spacing[100]} 0px ${spacing[72]};
  `}

  ${atMinWidth.xl`
    padding: ${spacing[112]} 0px ${spacing[96]};
  `}

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 5px;
    background: radial-gradient(
      ellipse farthest-corner at center center,
      #007bff 24%,
      transparent 76%
    );
  }
`;

export const OuterWrapper = styled.div`
  width: 100%;
  max-width: ${containers.md};

  display: flex;
  flex-direction: column;
  gap: ${spacing[32]};

  padding: ${spacing[0]} ${spacing[16]};
  margin: ${spacing[0]} auto;

  ${atMinWidth.sm`
    padding: ${spacing[0]} ${spacing[32]};
  `}

  ${atMinWidth.xl`
    max-width: ${containers.xl};
  `}
`;

export const InnerWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${spacing[32]};

  ${atMinWidth.sm`
    gap: ${spacing[48]};
  `}

  ${atMinWidth.xl`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${spacing[32]};
  `}
`;

export const Details = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[24]};
`;

export const Text = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[24]};

  .eyebrow {
    ${font('overline', 'md', '500')}
    color: ${color.blue[700]};
  }

  .heading {
    ${font('display', 'md', '500')}
    color: ${color.darkBlue[1000]};

    ${atMinWidth.sm`
      ${font('display', 'lg', '500')}
    `}
  }

  .subhead {
    ${font('text', 'lg', '400')}
    color: ${color.darkBlue[600]};

    ${atMinWidth.sm`
      ${font('text', 'xl', '400')}
    `}
  }
`;

export const Content = styled.div`
  width: 100%;

  .gatsby-image,
  img {
    width: 100%;
    max-height: 193px;
    aspect-ratio: 16 / 9;
    border-radius: ${spacing[24]};
    overflow: hidden;
    transform: translateZ(0);

    ${atMinWidth.xs`
      max-height: 396px;
    `}

    ${atMinWidth.xl`
      max-height: 333px;
    `}
  }
`;
